/* r18maten: group order. One stepper per colour and size (rendered by snippets/tt-groep.liquid), live piece count and total price.
   window.TTGroep is read by tt-pdp.js: active(), lines(), refresh(), error(). Without opening the panel nothing here changes the page. */
(function () {
  'use strict';
  var wrap = null, btn = null, panel = null;
  var fmt = function (c) { return window.ttMoney ? window.ttMoney(c) : (c / 100).toFixed(2); };
  function fields() { return panel ? [].slice.call(panel.querySelectorAll('input[data-tt-groep-aantal]')) : []; }
  function qty(i) { var n = parseInt(i.value, 10); return isNaN(n) ? 0 : Math.max(0, Math.min(99, n)); }
  var G = {
    perPiece: function () { return 0; }, // set by tt-pdp.js: style + size surcharge + extra designs, cents per piece
    isOpen: function () { return !!panel && !panel.hidden; },
    lines: function () {
      return fields().map(function (i) { return { variant: i.dataset.variant, qty: qty(i), kleur: i.dataset.kleur, maat: i.dataset.maat, cents: parseInt(i.dataset.cents, 10) || 0 }; })
        .filter(function (l) { return l.qty > 0; });
    },
    total: function () { return G.lines().reduce(function (n, l) { return n + l.qty; }, 0); },
    active: function () { return G.isOpen() && G.total() > 0; },
    centsTotal: function () { var t = 0; G.lines().forEach(function (l) { t += l.qty * (l.cents + G.perPiece()); }); return t; },
    error: function (msg) { var e = wrap && wrap.querySelector('[data-tt-groep-err]'); if (!e) return; var t = msg || ''; if (e.textContent !== t) e.textContent = t; if (e.hidden === !!t) e.hidden = !t; },
    refresh: function () {
      if (!wrap) return;
      var n = G.total(), t = wrap.querySelector('[data-tt-groep-totaal]'), p = wrap.querySelector('[data-tt-groep-prijs]'), s = wrap.querySelector('[data-tt-groep-sep]');
      var txt = n ? n + (n === 1 ? ' stuk' : ' stuks') : (t.getAttribute('data-leeg') || ''), price = n ? fmt(G.centsTotal()) : '';
      if (s && s.hidden === !!n) s.hidden = !n;
      if (t.textContent !== txt) t.textContent = txt;
      if (p.textContent !== price) p.textContent = price;
      if (n) G.error('');
    }
  };
  window.TTGroep = G;

  function init() {
    wrap = document.querySelector('[data-tt-groep-wrap]');
    if (!wrap) return;
    btn = wrap.querySelector('[data-tt-groep-open]'); panel = wrap.querySelector('[data-tt-groep]');
    function setOpen(open) {
      panel.hidden = !open; btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      G.error(''); G.refresh();
      document.dispatchEvent(new CustomEvent('tt:groep'));
    }
    // d34b: opened low on the screen, the size fields lay under the buy bar (fixed on a phone, sticky from 750); scroll just enough to show
    // them above it, never past the panel's own button
    function clear(el) {
      var blok = document.querySelector('.tt-koopblok'), r = el.getBoundingClientRect(), barTop = innerHeight;
      if (blok && /fixed|sticky/.test(getComputedStyle(blok).position)) { var b = blok.getBoundingClientRect(); if (b.bottom >= innerHeight - 2 && b.top < innerHeight) barTop = b.top; }
      var over = r.bottom + 12 - barTop, room = btn.getBoundingClientRect().top - 8;
      if (over > 0) window.scrollBy({ top: Math.min(over, Math.max(0, room)), behavior: window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
    }
    btn.addEventListener('click', function () { setOpen(panel.hidden); if (!panel.hidden) requestAnimationFrame(function () { clear(panel); }); });
    panel.addEventListener('focusin', function (e) { if (e.target.matches && e.target.matches('input[data-tt-groep-aantal]')) setTimeout(function () { clear(e.target.closest('[data-tt-groep-stap]') || e.target); }, 300); });
    // ?groep=1 (the groups page links here): open the panel and bring it into view.
    try {
      if (new URLSearchParams(window.location.search).get('groep') === '1') {
        setOpen(true);
        var calm = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        requestAnimationFrame(function () { wrap.scrollIntoView({ block: 'start', behavior: calm ? 'auto' : 'smooth' }); });
      }
    } catch (e) { /* no URL support: panel stays closed */ }
    wrap.addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest('[data-tt-groep-min],[data-tt-groep-plus]');
      if (!b) return;
      var i = b.parentNode.querySelector('input[data-tt-groep-aantal]');
      i.value = String(Math.max(0, Math.min(99, qty(i) + (b.hasAttribute('data-tt-groep-plus') ? 1 : -1))));
      G.refresh();
    });
    ['input', 'change'].forEach(function (ev) {
      wrap.addEventListener(ev, function (e) {
        if (!e.target.matches || !e.target.matches('input[data-tt-groep-aantal]')) return;
        if (ev === 'change') e.target.value = String(qty(e.target));
        G.refresh();
      });
    });
    G.refresh();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
